import { z } from "zod";

export const signInWithQrSchema = z.object({
	badgeId: z.uuid(),
	pin: z.string().length(4, "PIN must be 4 digits long"),
});

export type SignInWithQrSchema = z.infer<typeof signInWithQrSchema>;
